import { cloneDeep } from 'lodash';
import { getMatchingRoute, isAuthorizedForRoute } from 'src/utils/routeHelper';
import MenuItem from 'src/models/menu/menuItem';
import MenuItemGroup from 'src/models/menu/menuItemGroup';

export const getItems = (state) => {
  const items = cloneDeep(state.items);

  items.forEach((element) => {
    if (element instanceof MenuItemGroup) {
      element.menuItemsPrimary = element.menuItemsPrimary.filter((x) => {
        const route = getMatchingRoute(x.routeName);
        return isAuthorizedForRoute(route);
      });

      if (element.menuItemsSecondary) {
        element.menuItemsSecondary = element.menuItemsSecondary.filter((x) => {
          const route = getMatchingRoute(x.routeName);
          return isAuthorizedForRoute(route);
        });
      }
    }
  });

  return items.filter((element) => {
    if (element instanceof MenuItemGroup) {
      return (
        element.menuItemsPrimary.length > 0 || (element.menuItemsSecondary && element.menuItemsSecondary.length > 0)
      );
    }

    if (element instanceof MenuItem) {
      const route = getMatchingRoute(element.routeName);
      return isAuthorizedForRoute(route);
    }
  });
};
export const getIsLoading = (state) => state.isLoading;
export const getActiveSubMenuName = (state) => state.activeSubMenuName;
